import RotatePage from 'modules/board-master/ui/pages/common/rotate-page';
import size from 'modules/board-master/domain/constants/size';
import { Team } from 'modules/board-master/domain/intefaces';
import Advertisement from 'modules/board-master/ui/components/board/advertisement';
import Header from 'modules/board-master/ui/components/board/header';
import Period from 'modules/board-master/ui/components/board/period';
import Score from 'modules/board-master/ui/components/board/score';
import Timer from 'modules/board-master/ui/components/board/timer';
import { MainBlock } from './styles';

interface IProps {
  teams: [Team, Team];
  period: number;
  time: number;
  roundTo: 'floor' | 'ceil';
}

function Mobile(props: IProps) {
  const { teams, period, time, roundTo } = props;

  const orientation = window.screen.orientation.type.includes('portrait') ? 'portrait' : 'landscape';
  const isMobileInPortrait = orientation === 'portrait' && window.innerWidth < size.mobile.width;
  if (isMobileInPortrait) {
    return <RotatePage />;
  }

  return (
    <MainBlock>
      <Header value="ПРИВЕТСТВУЕМ УЧАСТНИКОВ ИГРЫ" />
      <div className="flex-center flex h-full flex-row">
        <Score id={'score'} score={teams[0].score} teamName={teams[0].name} />
        <div className="flex flex-col">
          <Period id="period" value={period} />
          <Timer id="timer" milliseconds={time} roundTo={roundTo} />
        </div>
        <Score id={'score'} score={teams[1].score} teamName={teams[1].name} />
      </div>
      <Advertisement />
    </MainBlock>
  );
}

export default Mobile;
